import dayjs, { Dayjs } from 'dayjs';
import { useTranslation } from 'react-i18next';
import { CustomDatePicker } from '~/components/Shared/CustomDatePicker/CustomDatePicker';
import CustomQuerySelect from '~/components/Shared/CustomQuerySelect/CustomQuerySelect';
import { useDebounce } from '@uidotdev/usehooks';
import styles from './EntertainmentReportExtra.module.scss';

interface IEntertainment {
  id: number;
  name: string;
}

interface EntertainmentReportExtraProps {
  startDate: Dayjs | null;
  endDate: Dayjs | null;
  onStartDateChange: (date: Dayjs | null) => void;
  onEndDateChange: (date: Dayjs | null) => void;
  entertainments: IEntertainment[];
  onEntertainmentsChange: (value: IEntertainment[]) => void;
  isAllChecked: boolean;
  onAllCheckedChange: (value: boolean) => void;
}

export const EntertainmentReportExtra = ({
  startDate,
  endDate,
  onStartDateChange,
  onEndDateChange,
  entertainments,
  onEntertainmentsChange,
  isAllChecked,
  onAllCheckedChange,
}: EntertainmentReportExtraProps) => {
  const { t } = useTranslation();
  const debouncedSearchTerm = useDebounce('', 500);

  const params = {
    sort: '',
    perPage: 100,
    field: '',
    query: debouncedSearchTerm,
    page: 1,
  };

  const disabledDate = (current: Dayjs) => {
    return current && current > dayjs().startOf('day');
  };

  return (
    <div>
      <CustomQuerySelect
        label={t('services')}
        query="admin/entertainment-objects"
        queryKey={['entertainment-objects', params]}
        placeholder={t('services')}
        params={params}
        value={entertainments}
        onChange={(value) => {
          if (Array.isArray(value)) {
            onEntertainmentsChange(value);
          }
        }}
        required
        disabled={isAllChecked}
        multiselect
        isSearchEnabled
        hasCheckbox={true}
        checkboxLabel={t('for_all_services')}
        setIsCheckedAll={(value) => onAllCheckedChange(value)}
      />

      <div className={styles.dateWrapper}>
        <span className={styles.labelText}>
          {t('date')}
          <span className={styles.labelStar}>*</span>
        </span>
        <CustomDatePicker
          value={[startDate, endDate]}
          showPresets={true}
          disabledDate={disabledDate}
          onChange={(name, value) => {
            if (name === 'start_date') {
              onStartDateChange(value);
            } else if (name === 'end_date') {
              onEndDateChange(value);
            }
          }}
        />
      </div>
    </div>
  );
};
